export const FRONTEND_BASE_URL = 'FRONTEND_BASE_URL';
export const DB_CONFIG = 'DB_CONFIG';
export const BCRYPT_SALT_ROUNDS = 'BCRYPT_SALT_ROUNDS';
export const MESSENGER_SERVICE = 'MESSENGER_SERVICE';
export const JWT_SECRET = 'JWT_SECRET';
export const ADMIN_ROLE = 3;

